import { sendRequest, sendRequestReport } from "../axios";
import { getReportUrl } from "../components/api/localglobal.js";
export default {
  state: {},
  mutations: {},
  actions: {
    generateExcell({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestReport(`generate`, "post", payload, reject).then(
          (response) => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    saveExcellToBack({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`excell`, "post", payload, reject).then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getExcellInvoce({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestReport(`invoce`, "post", payload, reject).then(
          (response) => {
            commit("SET_PROCESSING", false);
            resolve(response.data);
          }
        );
      });
    },
    getExcellReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestReport(`report`, "post", payload, reject).then(
          (response) => {
            commit("SET_PROCESSING", false);
            resolve(response.data);
          }
        );
      });
    },
    getWinnersListReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestReport(`winnerlist`, "post", payload, reject).then(
          (response) => {
            commit("SET_PROCESSING", false);
            resolve(response.data);
          }
        );
      });
    },
  },
  getters: {},
};
